import ApiClient from "../../../utils/api/ApiClient";
import { createSlice } from '@reduxjs/toolkit';

// export const LOADING_THEME_RECOMMEND_LIST = 'recommend/LOADING_THEME_RECOMMEND_LIST';
// export const FETCH_THEME_RECOMMEND_LIST = 'recommend/FETCH_THEME_RECOMMEND_LIST';

const initialState = {loading:true, list:[], result:null, message:null};
const themeRecommendListSlice = createSlice({
    name: 'themeRecommendList',
    initialState,
    reducers: {
        loading: (state) => {
            state.loading = true;
            state.result = null;
            state.message = null;
        },
        fetch: (state, action) => {
            state.loading = false;
            state.result = true;
            state.list = action.payload;
        }
    }
});

export default themeRecommendListSlice.reducer;
export const themeRecommendListActions = themeRecommendListSlice.actions;

export const fetchThemeRecommendList = ()=>{
	return function (dispatch) {
        
		dispatch( themeRecommendListActions.loading() );
        const { promise } = ApiClient({
            url:'/api/recommend/theme/list',
            authToken:sessionStorage.getItem('user')
        });

        promise.then(res => {
			dispatch( themeRecommendListActions.fetch(res.data) );
		}).catch(res => {
			console.log('catch');
			console.log(res)
		});
	}// return
};

export const fetchRecommendBookList = (id)=>{
	return function (dispatch) {
        const { promise } = ApiClient({
            method: 'GET',
			url: `/api/recommend/${id}/books`,
            authToken:sessionStorage.getItem('user')
        });
        return promise;
	}// return
};